// Self-registering plugin for the conversation internal counsel (REQ-20260810-03).
//
// Registers the Vuex module plus the two globally-mounted pieces of UI: the side
// panel (mounted once in the dashboard shell) and the auto reply switch
// (mounted in the reply composer). The ActionCable events are wired in
// `dashboard/helper/actionCable.js` (FORK_PATCH), which dispatches the actions
// exported by this module.
// Called once from `app/javascript/entrypoints/dashboard.js`.
import counselModule from './store';
import CounselPanel from './components/CounselPanel.vue';
import CounselAutoReplyStatus from './components/CounselAutoReplyStatus.vue';

export const COUNSEL_STORE_MODULE = 'counselFeature';

// ActionCable event names, mirrored from Counsel::SessionService.
export const COUNSEL_MESSAGE_CREATED = 'counsel.message_created';
export const COUNSEL_MESSAGE_DELETED = 'counsel.message_deleted';
export const COUNSEL_THREAD_CLEARED = 'counsel.thread_cleared';
export const COUNSEL_AUTO_REPLY_CHANGED = 'counsel.auto_reply_changed';
export const CONVERSATION_AGENT_ACTIVITY = 'conversation.agent_activity';

export const installCounsel = ({ app, store }) => {
  if (store && !store.hasModule(COUNSEL_STORE_MODULE)) {
    store.registerModule(COUNSEL_STORE_MODULE, counselModule);
  }
  if (app) {
    app.component('CounselPanel', CounselPanel);
    app.component('CounselAutoReplyStatus', CounselAutoReplyStatus);
  }
};

export default installCounsel;
